export default __webpack_public_path__ + "static/media/logoTitle.5e3699fe.png";